import { defineMessages } from 'react-intl';

export default defineMessages({
  caption: 'Delegation',
  descriptionFirst:
    'You can delegate your proposal/voting power to another Ethereum address without the SSAP/stkSSAP tokens leaving your wallet.',
  descriptionSecond:
    'To delegate to another address or to get your power back, simply delegate again to the address you want. (eg. Recover your power by delegating to your own Ethereum address)',
});
